import breadcrumbComp from "../../common/breadcrumb-comp.vue";
import EncryptUtility from "../../utility/js/encrypt-utility";
import AddFavourite from "../../utility/js/addFav";
import BackToTop from "../../common/back-to-top.vue";
import reportService from "./reports-service";       
import reportingService from "./reporting-service";  

export default {
  name: "auditWorkcenterDashboard",
  data() {
    return {
      userId: EncryptUtility.localStorageDecrypt("userID"),
      actionList: [],
      favouriteList: [],
      mainPage: "",
      subPage: "",
      backSlash: true,
      pageUrl: "",
      showAdd: false,
      refresh: true,
      selectedProject: "",
      projectList: [],
      selectedBusiness: "",
      businessList: [],
      showAllForm: false, 
      showSearch: false,   
      dashboardData: [],
      totalRecords: 0,
      searchDashboard: "",
      showData: false,
      headerReport: [
        { text: "Project",               value: "Project",   class: "primary customwhite--text" },
        { text: "Business",              value: "Business",  class: "primary customwhite--text" },
        { text: "Currently In Audit",    value: "CurrentlyInAudit",   class: "primary customwhite--text" },
        { text: "Total Audits",          value: "TotalAudits",   class: "primary customwhite--text" },
        { text: "Pass",                  value: "Pass",      class: "primary customwhite--text" },
        { text: "Fail",                  value: "Fail",      class: "primary customwhite--text" },
      ],

      // Payload sent to the backend API (AuditWorkCenterReportModel)
      filterObj: {
        proj_key: 0,   // 0 = ALL projects
        bu_key: 0,     // 0 = ALL businesses
      },
    };
  },

  async created() {
    this.route = this.$route.path.replace("/", "");
    let data = await AddFavourite.getPageAction(this.userId, this.route);
    this.actionList    = data.actionList;
    this.mainPage      = data.mainPage;
    this.favouriteList = data.favouriteList;
    this.pageUrl       = data.pageUrl;
    this.subPage       = data.subPage;
    this.showAdd       = data.showAdd;
    this.getProjectData();
  },

  methods: {
    addFav() {
      this.showAdd = !this.showAdd;
      AddFavourite.add_remove_Favourite(this.showAdd, this.userId, this.route);
    },

    //To bring page based actions to the page
    actionSetter(action) {
      if (this.actionList !== undefined && this.actionList !== null && this.actionList !== "") {
        let filter = this.actionList.filter((entry) => entry.SystemName === action);
        return filter !== undefined && filter !== null && filter.length == 1 ? true : false;
      } else return false;
    },

    // Load all projects and prepend an ALL option (proj_key = 0)
    async getProjectData() {
      let projData = await reportingService.getReportingGenericProjectList("get", this.userId);
      if (projData && Array.isArray(projData)) {
        this.projectList = [{ value: "ALL", value_id: 0 }, ...projData];
      }
    },

    // Project selection
    async onChangeProject() {
      this.selectedBusiness = "";
      this.businessList     = [];
      this.showAllForm      = false;
      this.showSearch       = false;
      this.dashboardData    = [];
      this.totalRecords     = 0;
      this.showData         = false;
      this.filterObj.bu_key = 0;

      if (parseInt(this.selectedProject) === 0) {
        this.showSearch = true;
        return;
      }

      // Specific project — load businesses for it
      let obj = { proj_key: parseInt(this.selectedProject) };
      let busData = await reportingService.getReportingGenericBusinessList("post", obj);
      if (busData && Array.isArray(busData)) {
        this.businessList = [{ value: "ALL", value_id: 0 }, ...busData];
        this.showAllForm = true;
      } else {
        let Alert = { type: "error", isShow: true, message: "No Business found for the selected Project" };
        this.$store.commit("ConfigModule/Alert", Alert);
      }
    },

    // Business selection — any choice (ALL or specific) shows Run
    onChangeBusiness() {
      this.dashboardData = [];
      this.totalRecords  = 0;
      this.showData      = false;
      this.showSearch    = true;
    },

    async onClickSearch() {
      this.filterObj.proj_key = parseInt(this.selectedProject) || 0;
      this.filterObj.bu_key   = parseInt(this.selectedBusiness) || 0;

      let data = await reportService.auditWorkcenterDashboard("post", this.filterObj, false);

      if (data && data.message !== "NA") {
        if (Array.isArray(data) && data.length > 0) {
          this.dashboardData = data;
          this.totalRecords  = data.length;
          this.showData      = true;
        } else {
          this.dashboardData = [];
          this.totalRecords  = 0;
          this.showData      = false;
          let Alert = { type: "error", isShow: true, message: "No records found for the selected criteria" };
          this.$store.commit("ConfigModule/Alert", Alert);
        }
      }
    },

    // Reset all selections and clear the dashboard results
    resetFunction() {
      this.selectedProject  = "";
      this.selectedBusiness = "";
      this.projectList      = [];
      this.businessList     = [];
      this.showAllForm      = false;
      this.showSearch       = false;
      this.dashboardData    = [];
      this.totalRecords     = 0;
      this.searchDashboard  = "";
      this.showData         = false;
      this.filterObj = { proj_key: 0, bu_key: 0 };
      this.getProjectData();
    },
  },

  components: {
    breadcrumbComp,
    BackToTop,
  },
};
